import {
  Box,
  FormLabel,
  useTheme
} from "@mui/material";
import React, {useEffect, useState} from "react";
import ViewMenu from "../../components/controls/ViewMenu";
import Tracking from "../../components/Tracking";
import ConversionsReport from "./reports/ConversionsReport";
import ReferrersReport from "./reports/ReferrersReport";
import SignupActivityReport from "./reports/SignupActivityReport";
import {openDrawerWidth} from "../../components/mui/Drawer";

enum AdminReportView {
  Conversions,
  Referrers,
  UserActivity
}

const AdminReportNames: string[] = [
  "Conversions",
  "Referrers",
  "Signup Activity"
]

const AdminReportsView = () => {
  const [reportView, setReportView] = useState<AdminReportView>(AdminReportView.Conversions)
  const [width, setWidth] = useState(window.innerWidth)
  const [contentWidth, setContentWidth] = useState<number>(0)

  const theme = useTheme()
  const styles = {
    formLabel: {
      fontSize: 12,
      fontWeight: 400,
      color: theme.palette.grey["700"],
    },
  }

  useEffect(() => {
    const handleResize = () => {
      const innerWidth = window.innerWidth
      setWidth(innerWidth);
      setContentWidth(innerWidth - openDrawerWidth)
    };
    handleResize()

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const renderViewMenu = () => {
    return (
      <ViewMenu
        view={reportView}
        variant="auto"
        options={AdminReportNames}
        onChange={(index: number) => {
          setReportView(index)
          Tracking.event({action: "Admin Report", label: AdminReportNames[index]})
        }}
      />
    )
  }

  return (
    <Box sx={{display:"flex", flexDirection:"column", mt:1, minHeight: "calc(100vh - 180px)"}}>
      <Box display="flex" flexDirection="column" alignContent="left" pl={2} height={50} mb="0px">
        <FormLabel sx={styles.formLabel}>View</FormLabel>
        {renderViewMenu()}
      </Box>

      <Box sx={{
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        // width: "100%",
        minHeight: "100%",
        maxHeight: "calc(100vh - 84px)",
        marginLeft: 0,
        marginRight: 1,
        overflowY:"scroll"
      }}>
        {reportView === AdminReportView.Conversions &&
          <ConversionsReport width={contentWidth}/>
        }
        {reportView === AdminReportView.Referrers &&
          <ReferrersReport width={contentWidth}/>
        }
        {reportView === AdminReportView.UserActivity &&
          <SignupActivityReport width={contentWidth}/>
        }
      </Box>
    </Box>
  )
}

export default AdminReportsView